import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { 
  Heart, 
  BarChart3, 
  FileText, 
  BookOpen, 
  Users
} from 'lucide-react';

const MobileNav = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Feature flags - set to false to hide features temporarily
  const SHOW_GROUP_THERAPY = false;

  const navItems = [
    { path: '/app', label: 'Home', icon: Heart },
    { path: '/app/dashboard', label: 'Progress', icon: BarChart3 },
    { path: '/app/assessments', label: 'Assess', icon: FileText },
    { path: '/app/journal', label: 'Journal', icon: BookOpen },
    { path: '/app/peer-support', label: 'Community', icon: Users },
    ...(SHOW_GROUP_THERAPY ? [{ path: '/app/group-therapy', label: 'Groups', icon: Users }] : []),
  ];

  const isActive = (path) => {
    if (path === '/app') {
      return location.pathname === '/app';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50">
      <div className="flex justify-around items-center py-2 px-1">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`flex flex-col items-center justify-center w-full py-2 px-1 rounded-lg transition-colors duration-200 ${
                active 
                  ? 'text-blue-600 bg-blue-50' 
                  : 'text-gray-600 hover:text-blue-600 hover:bg-gray-50'
              }`}
            >
              <Icon className={`w-5 h-5 mb-1 ${active ? 'fill-current' : ''}`} />
              <span className="text-xs font-medium">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileNav; 